import { Axios } from "../hooks/useAxiosInstance";

export const Inbox = (function () {


    const apis = () => ({
        fetch: async ({ api_token }) => await fetchRecord(api_token),
        fetchIndicatior: async ({ api_token }) => await fetchIndicatiorRecord(api_token),
    })

    async function fetchRecord(api_token) {
        const url = "api/admin/notification";
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.get(url, option);
    }
    async function fetchIndicatiorRecord(api_token) {
        const url = "api/admin/notification/indicator";
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.get(url, option);
    }

    return apis();

})()
